import React, {Component} from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
import {withStyles} from "@material-ui/core";

const vspacing = 20;

// pdfjs.GlobalWorkerOptions.workerSrc = "/pdfjsWorker.js";

class PDFViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
            pageWidth: 600,
        };

        if (this.props.doPage) {
            this.props.doPage((pageNumber) => {
                this.setState({pageNumber});
            })
        }
    }

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState({numPages});
        if (this.props.onDocumentLoadSuccess) {
            this.props.onDocumentLoadSuccess({numPages});
        }

        // const textLayers = document.querySelectorAll(".react-pdf__Page__textContent");
        // textLayers.forEach(layer => {
        //     const { style } = layer;
        //     style.top = "0";
        //     style.left = "0";
        //     style.transform = "";
        // });
    };

    updateDimensions = () => {
        this.setState({pageWidth: window.innerWidth - (vspacing * 2.5)});
    };

    componentDidMount = () => {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    };
    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    };

    render() {
        const {pageNumber, numPages} = this.state;
        const {classes} = this.props;

        return (
            <React.Fragment>
                <Document
                    className={classes.document}
                    file={this.props.filename}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                >
                    <Page
                        size="A4"
                        pageNumber={pageNumber}
                        className={classes.page}
                        width={this.state.pageWidth}
                        renderTextLayer={true}
                        onRenderError={(error) => alert('Error while loading page! ' + error.message)}
                        onGetAnnotationsError={(error) => alert('Error while loading annotations! ' + error.message)}
                        onGetTextError={(error) => alert('Error while loading text layer items! ' + error.message)}
                    />
                </Document>
            </React.Fragment>
        );
    }
}


const styles = theme => ({
    page: {
        textAlign: "center",
        display: 'inline-block', // important to get safe text selection position same to image!
    },
    document: {
        paddingLeft: vspacing,
        paddingTop: vspacing,
        backgroundColor: theme.colors.lightGreyBlue,
    },
});


export default withStyles(styles)(PDFViewer);



// WEBPACK FOOTER //
// ./resources/assets/js/components/File/PDFViewer.jsx